/**
 * SUI network selection.
 *
 * The union and the accessor live together so nothing else has to know that the
 * value comes from configuration at all.
 */
import { config } from "@/config";

/** The three networks the app can be pointed at. */
export type SuiNetwork = "mainnet" | "testnet" | "devnet";

/**
 * The configured network, defaulting to mainnet.
 *
 * Narrowing happens in `src/config/index.ts` (was `NEXT_PUBLIC_DEFAULT_SUI_NETWORK`,
 * now `VITE_SUI_NETWORK`), so an unrecognised value has already become
 * `"mainnet"` by the time it reaches here.
 */
export function getSuiNetwork(): SuiNetwork {
  return config.suiNetwork;
}
